<template>
  <div class="home-title" :style="{ height: height }">
    <img v-if="icon" :src="icon" />
    <span
      class="title-content"
      :style="{ fontSize: size + 'px', marginLeft: marginLeft }"
      ><slot></slot
    ></span>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "40px",
    },
    size: {
      type: Number,
      default: 16,
    },
    marginLeft: {
      type: String,
      default: "10px",
    },
  },
};
</script>

<style lang="less" scoped>
.home-title {
  width: 219px;
  height: 40px;
  border-radius: 8px 0 0 0;
  background-image: linear-gradient(
    to right,
    rgba(2, 189, 152, 0.2),
    rgba(255, 255, 255, 0.2)
  );
  display: flex;
  align-items: center;

  img {
    margin-left: 16px;
    width: 26px;
    height: 26px;
  }

  .title-content {
    height: 16px;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
    line-height: 16px;
    margin-left: 10px;
  }
}
</style>
